import { onMounted, onUnmounted, unref, watch } from 'vue'

/**
 * 按实际底栏高度写入 --bet-foot-space，选号区可动态铺满到红框上沿。
 * @param {import('vue').Ref<HTMLElement|null>|HTMLElement|null} footRef footer 元素
 * @param {import('vue').Ref<HTMLElement|null>|HTMLElement|null} [rootRef] 写入 CSS 变量的根（默认 foot 最近的 page-wrap / keno8-page）
 */
export function useBetFootSpace(footRef, rootRef) {
  let ro = null

  const resolveEl = (r) => {
    const v = unref(r)
    return v && v.$el ? v.$el : v
  }

  const apply = () => {
    const foot = resolveEl(footRef)
    if (!foot || typeof foot.getBoundingClientRect !== 'function') return
    const h = Math.ceil(foot.getBoundingClientRect().height)
    if (h <= 0) return
    const root =
      resolveEl(rootRef) ||
      foot.closest('.page-wrap, .keno8-page') ||
      document.documentElement
    root.style.setProperty('--bet-foot-space', `${h}px`)
  }

  const bind = () => {
    ro?.disconnect()
    ro = null
    const foot = resolveEl(footRef)
    apply()
    if (foot && typeof ResizeObserver !== 'undefined') {
      ro = new ResizeObserver(() => apply())
      ro.observe(foot)
    }
  }

  onMounted(() => {
    bind()
    requestAnimationFrame(apply)
    window.addEventListener('resize', apply)
  })

  onUnmounted(() => {
    ro?.disconnect()
    ro = null
    window.removeEventListener('resize', apply)
  })

  watch(
    () => unref(footRef),
    () => {
      bind()
    }
  )

  return { syncFootSpace: apply }
}
